/* 布局 */
//前台
import Layout from "@views/layout";

const orderashreturnreserveRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "orderashreturnreserve/list",
        name: "ORDERASHRETURNRESERVE",
        meta: {
            title: "骨灰返送订单",
            keepAlive:true
        },
        component: () => import("@views/business/orderashreturnreserve/index.vue"),
    },
        ],
};

export default orderashreturnreserveRouter;
